"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHouseholdSizeFromPersonCount = exports.isStudentFromEnrolled = void 0;
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const helpers_1 = require("evolution-common/lib/services/odSurvey/helpers");
const helpers_2 = require("evolution-common/lib/utils/helpers");
const isSchoolEnrolledTrueValues = [
    'kindergarten',
    'childcare',
    'primarySchool',
    'secondarySchool',
    'schoolAtHome',
    'other'
];
// TODO: Migrate all these useful helpers (or not) to Evolution
const isStudentFromEnrolled = (person) => {
    const schoolType = person.schoolType;
    return !(0, LodashExtensions_1._isBlank)(schoolType) && isSchoolEnrolledTrueValues.includes(schoolType);
};
exports.isStudentFromEnrolled = isStudentFromEnrolled;
// Make sure the household size matches the number of persons in the household,
// in case the participant changed one value but did not reach the household
// section again.
// FIXME This won't be necessary when https://github.com/chairemobilite/evolution/issues/1132 is fixed
const updateHouseholdSizeFromPersonCount = (interview) => {
    const householdSize = (0, helpers_2.getResponse)(interview, 'household.size', undefined);
    const persons = (0, helpers_1.getPersonsArray)({ interview });
    if (!(0, LodashExtensions_1._isBlank)(householdSize) && persons.length > 0 && householdSize !== persons.length) {
        return { 'response.household.size': persons.length };
    }
    return undefined;
};
exports.updateHouseholdSizeFromPersonCount = updateHouseholdSizeFromPersonCount;
